import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import ptBR from './pt-BR'
import enUS from './en-US'
import esES from './es-ES'

const resources = {
  'pt-BR': {
    translation: ptBR,
  },
  'en-US': {
    translation: enUS,
  },
  'es-ES': {
    translation: esES,
  },
}

// Detectar idioma do navegador ou usar pt-BR como padrão
const getInitialLanguage = (): string => {
  const saved = localStorage.getItem('galatea_language')
  if (saved) return saved

  const browserLang = navigator.language || 'pt-BR'
  if (browserLang.startsWith('pt')) return 'pt-BR'
  if (browserLang.startsWith('en')) return 'en-US'
  if (browserLang.startsWith('es')) return 'es-ES'
  return 'pt-BR' // Padrão
}

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: getInitialLanguage(),
    fallbackLng: 'pt-BR',
    interpolation: {
      escapeValue: false, // React já faz escape
    },
    react: {
      useSuspense: false,
    },
  })

// Listener para mudanças de idioma
i18n.on('languageChanged', (lng) => {
  localStorage.setItem('galatea_language', lng)
})

export default i18n
